import ImageModel from './image';
var ImageModels = {
  image: ImageModel
};
export default ImageModels;
//# sourceMappingURL=index.js.map